import { Base } from './Base';

import animateScrollTo from 'animated-scroll-to';

export class ScrollToTrigger extends Base {
  constructor(behaviorName, element) {
    super(behaviorName, element);
    this.init();
  }

  init() {
    this.bindClickHandler();
  }

  bindClickHandler() {
    this.element.addEventListener('click', (e) => {
      e.preventDefault();
      this.performScrollTo();
    });
  }

  performScrollTo() {
    const target = document.querySelector(this.element.getAttribute('href'));

    if (target) {
      animateScrollTo(target, {
        maxDuration: 1000
      });
    }
  }
}